import ScrollPane from "../../../../../shared/lib/html5-software-library/src/ranj/components/scrolling/ScrollPane";
import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import PuzzleModel from "../model/PuzzleModel";
import GameElementSkinFactory from "./GameElementSkinFactory";
import ItemView from "./ItemView";

export default class PuzzleView extends AbstractView {

    /**
     * 
     * @param {createjs.Container} target 
     * @param {PuzzleModel} puzzleModel 
     * @param {GameElementSkinFactory} elementFactory 
     */
    constructor(target, puzzleModel, elementFactory, layoutManager) {
        super(target);
        this._model = puzzleModel;

        this._build(elementFactory, layoutManager);
    }

    destroy() {
        super.destroy();
        this.stopDragNudge();
    }

    get target() {
        return this._target;
    }

    /**
     * @param {GameElementSkinFactory} elementFactory 
     * @param {LayoutManager} layoutManager 
     */
    _build(elementFactory, layoutManager) {
        const skin = this._target.addChild(elementFactory.getLocation(this._model.location));
        this._locationSkin = skin;
        this._locationSkin.gotoAndStop(0);

        //TODO: make scrollpane stuff more robust when/if we move from prototype to real game

        //ScrollPane ignores x and y values of viewport and content bounds! So make sure both are at 0,0.
        const vp = layoutManager.getViewport(this._target);
        vp.y = 0;
        vp.height -= 350;//minus huds
        this._scrollpane = new ScrollPane(vp, null, null, this._locationSkin, null, true, false, 0, this._target.stage);
        this._scrollpane.addEventListener(ScrollPane.SCROLL_STARTED, this._handleScrollStarted.bind(this))

        const b = elementFactory.getLocationBounds(this._model.location);
        this._scrollpane.setClickMargin(12);
        this._scrollpane.setBounds(b.x, b.y, b.width, b.height);
        //center 
        this._center = new createjs.Point(-(b.width - vp.width) / 2, -(b.height - vp.height) / 2);
        this._scrollpane.setScrollPosition(this._center.x, this._center.y);

        this._model.slots.forEach((itemIndex, index) => {
            const target = skin["slot" + index];
            const itemView = new ItemView(target);
            itemView.content = elementFactory.getItem(itemIndex);
            target.addEventListener("click", this._buildClickHandler(itemView, index, itemIndex));
        });
    }

    _buildClickHandler(itemView, slotIndex, itemIndex) {
        return e => {
            if (this.enabled) {
                this.checkBird(itemView, slotIndex, itemIndex);
            }
        }
    }

    checkBird(itemView, slotIndex, itemIndex) {
        this.dispatchEvent(PuzzleView.SELECT, slotIndex);
        //TODO: do all via model or events
        if (itemIndex == this._model.target) {
            itemView.disappear();
        } else {
            itemView.hop();
        }
    }

    _handleScrollStarted() {
        this.stopDragNudge();
    }

    animateOut(duration = 200, delay = 0, callback = null) {
        const props = {};
        if (callback != null) {
            props.onComplete = callback;
        }
        createjs.Tween.get(this._target, props).wait(delay).to({ alpha: 0 }, duration, createjs.Ease.quadIn);
    }

    animateIn(duration = 200, delay = 0, callback = null) {
        const props = {};
        if (callback != null) {
            props.onComplete = callback;
        }
        this._target.alpha = 0;
        createjs.Tween.get(this._target, props).wait(delay).to({ alpha: 1 }, duration, createjs.Ease.quadOut);
    }

    doDragNudge() {
        const dx = 250, dy = 0;
        const wait = 0;
        const ox = this._scrollpane.getX();
        const oy = this._scrollpane.getY();
        const proxy = { x: ox, y: oy };
        const onChange = _ => {
            this._scrollpane.setScrollPosition(proxy.x, proxy.y);
        }
        this._dragNudgeTween = createjs.Tween.get(proxy, { onChange: onChange })
            .to({ x: ox + dx, y: oy + dy }, 600, createjs.Ease.quadInOut)
            .wait(wait)
            .to({ x: ox, y: oy }, 600, createjs.Ease.quadInOut)
            .wait(wait)
            .to({ x: ox - dx, y: oy - dy }, 600, createjs.Ease.quadInOut)
            .wait(wait)
            .to({ x: ox, y: oy }, 600, createjs.Ease.quadInOut);
    }

    stopDragNudge() {
        if (this._dragNudgeTween) {
            createjs.Tween.removeTweens(this._dragNudgeTween.target);
            this._dragNudgeTween = null;
        }
    }

    set enabled(bool) {
        this._enabled = bool;
    }

    get enabled() {
        return this._enabled;
    }
}

PuzzleView.SELECT = "PuzzleView.SELECT";